export default __webpack_public_path__ + "9d195342f3b294fa047194ea8bc9d58d.png";